import React, { useState } from "react";

import FormControl from '@mui/material/FormControl';
import { useObjectStore } from "../zustand/objects";
import { Input, Switch, Text, Group, Slider, ActionIcon } from '@mantine/core';



const ProjectName = () => {

  const { projectName, updateProjectName } = useObjectStore();
  
  const [editing, setEditing] = useState(false)

  const handleClick = () => {
    setEditing(true)
  }

  const handleSubmit = (val) => {
    updateProjectName(val)
    setEditing(false)
  } 

   

  return (
    
      <>
      {editing ?
        <FormControl onBlur={(e) => handleSubmit(e.target.value)} style={{maxWidth:500}}>
          <Input size="xs" defaultValue={projectName} autoFocus variant="outlined" onKeyPress={(e) => { if (e.key === 'Enter') { handleSubmit(e.target.value) } }} />
        </FormControl>
        :
        <><Text 
          size={'xl'}
          fw={750}
          // c={"#424242"}
        style={{whiteSpace:'nowrap', marginLeft:5, marginRight:5, textOverflow: 'ellipsis', overflow:'hidden', maxWidth:200}} onClick={() => handleClick()}
        >
          {projectName}
        </Text>
        </>}
        </>

  );
};


export default ProjectName;
